// extracted by mini-css-extract-plugin
export default {"searchIllustration":"styles-module__searchIllustration__a267be89dcebb58104ac"};